export default function convertDiscordImageUrl(url, actuallyConvert = false) {
  if (!actuallyConvert) return url;

  if (url.startsWith('https://d9mwibab5tete.cloudfront.net')) {
    return url.replace('https://d9mwibab5tete.cloudfront.net', '');
  }

  if (url.startsWith('https://arweave.net')) {
    return url.replace('https://arweave.net', '/arweave');
  }

  if (url.startsWith('https://res.cloudinary.com')) {
    return url.replace('https://res.cloudinary.com', '/cloudinary');
  }

  return url;
}
